import { Title, Kicker } from "./bits";
import { T } from "./content";

export default function Carte({ lang }) {
  const t = T[lang];
  return (
    <section className="section" id="carte" data-testid="section-carte">
      <div className="container">
        <div className="section-head reveal">
          <Kicker withDash>{t.carteKicker}</Kicker>
          <Title parts={t.carteTitle} tag="h2" />
        </div>

        <div className="carte reveal" data-testid="carte-plate">
          <div className="carte__grid" aria-hidden="true" />
          <div className="carte__marker" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <div className="carte__label">
            <span className="carte__city">LUXEMBOURG</span>
            <span className="carte__coords">{t.carteCoords}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
